import * as React from 'react';
import { GridRowsImage } from './components/GridRowsImage';

export const NoResultsOverlay = () => {
  return <GridRowsImage label="No Results Found by Your Query" />;
};
